<template>
    <div>
        Station Stats
    </div>
</template>
<script>
    export default {
        data() {
            return {
                
            }
        }
    }
</script>